import { escapeHtml, formatMinutes, glyph } from "../lib/util.js";
import { state } from "../lib/state.js";
import { addToCart } from "../lib/cart.js";
import { navigate } from "../lib/router.js";

export function renderFarm(els) {
  const crops = state.crops || [];
  els.farmPanel.innerHTML = `
    <header class="view-head">
      <h2 class="view-title">Farm planner</h2>
      <p class="view-lead">Grow times and seed queues for your cart. Times are approximate starter values.</p>
    </header>
    <ul class="stack-list">
      ${crops
        .map(
          (crop) => `
        <li class="stack-card">
          <div class="stack-main">
            ${glyph(crop.name, crop.colour)}
            <div>
              <button type="button" class="linkish" data-item="${escapeHtml(crop.slug)}">${escapeHtml(crop.name)}</button>
              <p class="muted">${escapeHtml(formatMinutes(crop.growMinutes))} · seed: ${escapeHtml(crop.seedName)}</p>
              <p class="notes">${escapeHtml(crop.notes || "")}</p>
            </div>
          </div>
          <div class="stack-actions">
            <label class="qty-label">
              <span class="sr-only">Seed quantity</span>
              <input type="number" min="1" value="10" class="qty-input" data-qty-for="${escapeHtml(crop.seedSlug)}" />
            </label>
            <button type="button" class="btn" data-add-seed="${escapeHtml(crop.seedSlug)}" data-name="${escapeHtml(crop.seedName)}">
              Queue seeds
            </button>
            <button type="button" class="btn ghost" data-add-crop="${escapeHtml(crop.slug)}" data-name="${escapeHtml(crop.name)}">
              Queue crop
            </button>
          </div>
        </li>`
        )
        .join("")}
    </ul>
  `;
}

export function bindFarm(els) {
  els.farmPanel.addEventListener("click", (e) => {
    const item = e.target.closest("[data-item]");
    if (item) {
      navigate("item", item.dataset.item);
      return;
    }
    const seedBtn = e.target.closest("[data-add-seed]");
    if (seedBtn) {
      const input = els.farmPanel.querySelector(`[data-qty-for="${seedBtn.dataset.addSeed}"]`);
      const qty = Number(input?.value || 10);
      addToCart(seedBtn.dataset.addSeed, qty, seedBtn.dataset.name);
      seedBtn.textContent = "Queued ✓";
      setTimeout(() => {
        seedBtn.textContent = "Queue seeds";
      }, 900);
      return;
    }
    const cropBtn = e.target.closest("[data-add-crop]");
    if (cropBtn) {
      const seedSlug = state.crops.find((c) => c.slug === cropBtn.dataset.addCrop)?.seedSlug;
      const input = seedSlug
        ? els.farmPanel.querySelector(`[data-qty-for="${seedSlug}"]`)
        : null;
      const qty = Number(input?.value || 10);
      addToCart(cropBtn.dataset.addCrop, qty, cropBtn.dataset.name);
      cropBtn.textContent = "Queued ✓";
      setTimeout(() => {
        cropBtn.textContent = "Queue crop";
      }, 900);
    }
  });
}
